import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-row flex-wrap align-items-center" }
const _hoisted_2 = { class: "pageCaption ps-2" }
const _hoisted_3 = {
  key: 0,
  class: "spinner-border ms-2",
  role: "status"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["title", "disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "spinner-border ms-2",
  role: "status"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["title", "disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-xls" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["title", "disabled"]
const _hoisted_16 = { class: "btn-group" }
const _hoisted_17 = ["title", "disabled"]
const _hoisted_18 = ["title", "disabled"]
const _hoisted_19 = ["title", "disabled"]
const _hoisted_20 = { class: "countLabel" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "d-flex flex-column flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReviewTaskSearchWidget = _resolveComponent("ReviewTaskSearchWidget")!
  const _component_ReviewTaskListWidget = _resolveComponent("ReviewTaskListWidget")!
  const _component_PasswordDialog = _resolveComponent("PasswordDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(this.caption), 1),
      (this.loadingPdf)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-sm btn-outline-secondary ms-3",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('general.export.pdf'),
            disabled: this.asyncRunning,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (this.exportToPdf()))
          }, _hoisted_8, 8, _hoisted_6)),
      (this.loadingXls)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
        : (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "btn btn-sm btn-outline-secondary ms-2",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('general.export.xls'),
            disabled: this.asyncRunning,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.exportToXls()))
          }, _hoisted_14, 8, _hoisted_12)),
      _createElementVNode("button", {
        class: "btn btn-primary ms-4",
        "data-bs-toggle": "tooltip",
        title: _ctx.$t('task.page.myTasksTooltip'),
        disabled: this.asyncRunning,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (this.showMyTasks()))
      }, _toDisplayString(_ctx.$t('task.page.myTasksTitle')) + " " + _toDisplayString(this.taskCounts != null ? this.taskCounts.ownTaskCount : ''), 9, _hoisted_15),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          class: "btn btn-success ms-4 btn-sm",
          "data-bs-toggle": "tooltip",
          title: _ctx.$t('task.page.signatureFolderTooltip'),
          disabled: this.asyncRunning,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (this.showSignatureFolder()))
        }, _toDisplayString(_ctx.$t('task.page.signatureFolderTitle')) + " " + _toDisplayString(this.taskCounts != null ? this.taskCounts.batchTaskCount : ''), 9, _hoisted_17),
        (this.mayQueryLateReviews)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-warning sm-2 btn-sm",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('task.page.surveillanceTooltip'),
              disabled: this.asyncRunning,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (this.showBelatedTasks()))
            }, _toDisplayString(_ctx.$t('task.page.surveillanceTitle')) + " " + _toDisplayString(this.taskCounts != null ? this.taskCounts.lateTaskCount : ''), 9, _hoisted_18))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-secondary sm-2 btn-sm",
          "data-bs-toggle": "tooltip",
          title: _ctx.$t('task.page.doneTasksTooltip'),
          disabled: this.asyncRunning,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (this.showDoneTasks()))
        }, _toDisplayString(_ctx.$t('task.page.doneTasksTitle')), 9, _hoisted_19)
      ]),
      _createVNode(_component_ReviewTaskSearchWidget, {
        onDoSearch: _ctx.doSearch,
        asyncRunning: this.asyncRunning,
        ref: "searchWidget",
        taskCounts: this.taskCounts,
        initialized: this.initialized,
        searchModelProp: this.searchModel,
        "onUpdate:searchModelProp": _cache[6] || (_cache[6] = ($event: any) => ((this.searchModel) = $event)),
        "onUpdate:quickFilter": _cache[7] || (_cache[7] = ($event: any) => {this.quickFilter = $event; _ctx.LocalStorageHelper.storeInLocalStorage([ this.ctx.principal ], '/task/quickSearch', this.quickFilter);})
      }, null, 8, ["onDoSearch", "asyncRunning", "taskCounts", "initialized", "searchModelProp"])
    ]),
    _createVNode(_component_ReviewTaskListWidget, {
      tasks: this.tasks,
      mode: _ctx.mode,
      onRemoveTask: _ctx.removeTask,
      ref: "listWidget",
      onToSignatureFolder: _ctx.toSignatureFolder,
      asyncRunningPage: this.asyncRunning,
      quickFilter: _ctx.quickFilter
    }, null, 8, ["tasks", "mode", "onRemoveTask", "onToSignatureFolder", "asyncRunningPage", "quickFilter"]),
    _createElementVNode("div", _hoisted_20, _toDisplayString(this.countLabelString), 1),
    (this.isBatchMode && this.selectedTasks.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary m-2 ms-5",
            disabled: this.asyncRunning,
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (this.signSelectedTasks && this.signSelectedTasks(...args)))
          }, _toDisplayString(_ctx.$t('review.review.entry.signChosen')), 9, _hoisted_22)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PasswordDialog, {
      class: "reviewTaskBatchPasswordDialog",
      title: _ctx.$t('review.review.entry.signTitle'),
      submitLabel: _ctx.$t('general.sign'),
      ref: "passwordDialog",
      extraClasses: "modal-xl reviewTaskBatchPasswordDialog"
    }, {
      upperContent: _withCtx(({ }) => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_ReviewTaskListWidget, {
            sizeClass: "signatureTaskListBaseDiv",
            restrictToSignatureSignColumns: true,
            tasks: this.selectedTasks,
            mode: _ctx.mode,
            onRemoveTask: _ctx.removeTask,
            onToSignatureFolder: _ctx.toSignatureFolder,
            asyncRunningPage: this.asyncRunning,
            storageKey: "signatureTaskList",
            quickFilter: _ctx.quickFilter
          }, null, 8, ["tasks", "mode", "onRemoveTask", "onToSignatureFolder", "asyncRunningPage", "quickFilter"])
        ])
      ]),
      _: 1
    }, 8, ["title", "submitLabel"])
  ], 64))
}